import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import { Grid, Row, Col } from '@vds/grids';

// import { Title, Body } from '../../../common/Typography/index';
import Button from '../../common/Button';
import { viewport } from '../../common/Helpers/index';
import DueToday from '../Cart/redesign/Components/dueToday';
import DueMonthly from '../Cart/redesign/Components/dueMonthly';
import { goToProcessStep } from '../../../redirection';
import { checkCartidAndLQResponse } from '../../common/Helpers/commonLog';

import './creditedge.css';

class EdgeIneligible extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('creditEdgeIneligible');
    this.state = {
      showDueData: false,
      showText: true,
    };
  }

  componentDidMount() {
    this.props.swithToFRP();
  }

  onClickEdgeIneligible = () => {
    this.setState({
      showDueData: true,
      showText: false,
    });
    this.props.creditInEligibleClicked('Y');
  };

  onClickNext = () => {
    goToProcessStep(this.props.currentView, this.props.history);
  };

  render() {
    const {
      dueTodayTitle,
      dueTodaySectionTitlle_1,
      dueTodaySectionTitlle_2,
      orderDetails,
      shippingDetails,
      dueTodayTaxesDetails,
      plansReferenceData,
      dueTodayPageName,
      dueTodayShippingText,
      dueTodayDisplayText,
      dueTodayList,
      dueMonthlytitle,
      dueMonthlysectionTitlle_1,
      dueMonthlysectionTitlle_2,
      dueMonthlyList,
      dueMonthlyplanInfoTitle,
      dueMonthlybroadbandInfoTitle,
      dueMonthlyTaxes,
      dueMonthlyorderDetailsView,
      dueMonthlypageName,
      dueMonthlyltePlanInfoTitle,
      dueMonthlyimportantProduct,
    } = this.props;

    const type = viewport();

    return (
      <>
        <Grid className="creditStatusGrid">
          <Row>
            {this.state.showText && (
              <div>
                <Row className="creditmsg paddingTop">
                  <Col colSizes={{ desktop: 7, mobile: 4, tablet: 12 }}>
                    <h1>{this.props.heading}</h1>
                  </Col>
                </Row>
                <Row className="noSideMargin pad20 onlyTopPad">
                  <Col colSizes={{ desktop: 3, mobile: 4, tablet: 4 }}>
                    <Button size="large" width={type === 'mobile' ? '295px' : '205px'} onClick={() => this.onClickEdgeIneligible()}>
                      Continue
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
          </Row>
          <Row className="noSideMargin pad20 onlyTopPad bottomSpace">
            <div className="paddingTop">
              {this.state.showDueData && (
                <div>
                  <h1>
                    {orderDetails &&
                      orderDetails?.dueTodayAmount &&
                      `You will pay the full $${parseFloat(orderDetails.dueTodayAmount).toFixed(2)} cost of the equipment today.`}
                  </h1>
                  <DueToday
                    cartDetails={dueTodayList}
                    orderDetails={orderDetails}
                    shippingDetails={shippingDetails}
                    title={dueTodayTitle}
                    sectionTitlle_1={dueTodaySectionTitlle_1}
                    sectionTitlle_2={dueTodaySectionTitlle_2}
                    pageName={dueTodayPageName}
                    shippingText={dueTodayShippingText}
                    displayText={dueTodayDisplayText}
                    plansReferenceData={plansReferenceData}
                    dueTodayTaxesDetails={dueTodayTaxesDetails}
                  />
                  <DueMonthly
                    title={dueMonthlytitle}
                    sectionTitlle_1={dueMonthlysectionTitlle_1}
                    sectionTitlle_2={dueMonthlysectionTitlle_2}
                    cartDetails={dueMonthlyList}
                    plansReferenceData={plansReferenceData}
                    planInfoTitle={dueMonthlyplanInfoTitle}
                    broadbandInfoTitle={dueMonthlybroadbandInfoTitle}
                    dueMonthlyTaxesDetails={dueMonthlyTaxes}
                    orderDetails={dueMonthlyorderDetailsView}
                    dueMonthlyState={dueMonthlyList}
                    pageName={dueMonthlypageName}
                    ltePlanInfoTitle={dueMonthlyltePlanInfoTitle}
                    importantProduct={dueMonthlyimportantProduct}
                  />
                  <Button size="large" width={type === 'mobile' ? '295px' : '205px'} onClick={() => this.onClickNext()}>
                    Continue
                  </Button>
                </div>
              )}
            </div>
          </Row>
        </Grid>
      </>
    );
  }
}
export default EdgeIneligible;
